import React from 'react';

const RetouchingEditingBanner = () =>{
    return (
        <>
        <div className='cadEditingBanner cadModelingMain cadAboutBanner cadContactBanner'>
            <img 
            src="/assets/cad-editing-banner.webp"
            alt="cad-editing-banner" />
            <div className='container'>
                <div className='cadContactBannerContent'>
                    <h1>Cad Editing</h1>
                </div>
            </div>
        </div>
        </>
    );
}

export default RetouchingEditingBanner;